import React from "react";
import { Card } from "react-bootstrap";

function LearnMore({ title, subject, src, modal }) {
  return (
    <Card className="learn-more">
      <Card.Body>
        <div className="text">
          <h5>{title}</h5>
          <small>{subject}</small>
        </div>
        <div className="link">
          {modal ? (
            <>{modal}</>
          ) : (
            // <a className="outer-link">
            //   Learn more
            //   <i className="las la-arrow-up"></i>
            // </a>
            <span></span>
          )}

          <img src={src} alt="bitcoin" />
        </div>
      </Card.Body>
    </Card>
  );
}

export default LearnMore;
